import { z } from "zod";
import { mediaSchema } from "../zod/mediaSchema.js";

export const galleryBlockSchema = z.object({
	images: z.array(mediaSchema).min(1),
});
